import { get } from "api/apiBridges/httpBridge";
import { useEffect, useMemo, useState } from "react";
import { Button, Card, CardContent, Dialog, IconButton, MenuItem, Select,  Typography } from "@mui/material";
import Scrollbars from "rc-scrollbars";
import { useDispatch, } from "react-redux";
import _ from "lodash";
import { useLocalNotifications } from "components/Events";
import { setState } from "store/slices/dealTab";
import { ReportTable } from "components/reportTable";
import { getDataSource } from "api/ds";
import Loading from 'components/Load';
import { ProductMoreInfo } from "utils/formatters";
import PrintIcon from '@mui/icons-material/Print';
import { genDoc } from "./genDoc";
import { useNavigate } from "react-router-dom";
import { hoverStyle } from "styles/main";

export default function MoveGuideDialog({deal_id, open, onClose, admin = true}){

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [CDN, setCDN] = useState(undefined);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const responseData = await get('Deal/getMoveGuide', { did: deal_id });
        const respCDN = await get('Deal/getCDN', { did: deal_id });
        setCDN(respCDN.message)
        let deals = {}

        console.log("responseData", responseData)

        responseData.map((el) => {
          if (el.count > 0) {
            console.log(el.deal_id)
            if (!deals[el.deal_id]) {
              deals[el.deal_id] = {
                deal: el.deal,
                deal_id: el.deal_id,
                products: [
                ],
                boxes: []
              }
            }
            if (el.product) {
              deals[el.deal_id].products.push(
                { box: el.box, count: el.count, addr: el.addr, 
                  product: {
                    nmID: el.product.nmID,
                    photo: el.product.data.photo,
                    barcode: el.product.size.barcode,
                    color: el.product.color,
                    vendorCode: el.product.vendorCode,
                    title: el.product.data.title,
                    sizeTitle: el.product.size.title
                  }
                }
              )
            }
            else {
              deals[el.deal_id].boxes.push(
                { box: el.box, addr: el.addr}
              )
            }
          }
        });
        console.log("deals", deals)
        setData(deals);

      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [deal_id]);

  const printMoveGuide = () => {

    let items = []
    Object.values(data).map((deal) => {
      deal.boxes.map((box) => {
        items.push({
          deal: deal.deal,
          box: box.box,
          addr: box.addr || "",
          count: "-",
          title: "-",
          barcode: "",
          color: "",
          vendor_code: "",
          size_title: ""
        })
      })
      deal.products.map((pr) => {
        items.push({
          deal: deal.deal,
          box: pr.box === '0'? 'Нераспределенный товар': pr.box || '-',
          addr: pr.addr  || "",
          count: pr.count,
          title: pr.product.title,
          barcode: pr.product.barcode,
          color: pr.product.color || "без цвета",
          vendor_code: pr.product.vendorCode || "",
          size_title: pr.product.sizeTitle ||  ""
        })
      })
    })
    let obj = {
        items,
        result_deal: CDN
    }
    console.log("TEEEESt", obj)
    genDoc("template_move_guide", obj, `Сбор товара ${CDN}`)
  }
  
  return (
    <Dialog
      open={open}
      maxWidth={false}
      PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
      onClose={onClose}
    >
      <div style={{height: '620px', width: '1000px', display: 'flex', flexDirection: 'row'}}>
        {loading? 
        <Loading/>
        :
        <Scrollbars autoHide style={{height: '88%', width: '98%', margin: "1%", display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          {Object.values(data).map((deal) => {
            console.log("AAAAAAAAAAAAAA", deal)
            return (
              <Card style={{width: 'calc( 100% - 20px)', borderRadius: '10px', margin: '10px', boxShadow: '0px 0px 10px rgba(0,0,0,0.2)'}}>
                <CardContent style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                  {!admin || deal.deal_id === 0 ?
                    <Typography sx={{color: '#078376', fontWeight: 'bold', marginBottom: '10px', }}>{deal.deal_id === 0? "": "СДЕЛКА"} {deal.deal}</Typography>
                  :
                    <Button
                      variant="text"
                      sx={{
                        color: '#078376',
                        fontWeight: 'bold',
                        marginBottom: '10px',
                        textTransform: 'none',   
                        padding: 0,              
                        minWidth: 0,             
                      }}
                      onClick={() => { navigate(`/deal/${deal.deal_id}`); }}
                    >
                      СДЕЛКА {deal.deal}
                    </Button>
                  }
                  <div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginBottom: '10px'}}>
                      {deal.boxes.map((box) => 
                        <Card style={{margin: '10px', width: '22%', borderRadius: '10px', boxShadow: '0px 0px 10px rgba(0,0,0,0.2)'}}>
                          <CardContent style={{paddingBottom: '12px'}}>
                            { box.box && <Typography sx={{fontSize: '10pt', lineHeight: '12pt'}}>Короб: {box.box}</Typography>}
                            { admin && box.addr && <Typography sx={{fontSize: '10pt', color: 'gray', lineHeight: '12pt'}}>Адрес: {box.addr}</Typography>}
                          </CardContent>
                        </Card>          
                      )}      
                  </div>
                  <div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', gap: 12}}>
                      {deal.products.map((pr) => 
                        <Card style={{margin: '10px', width: '47%', borderRadius: '10px', boxShadow: '0px 0px 10px rgba(0,0,0,0.2)' }}>
                          <CardContent style={{display: 'flex', flexDirection: 'column'}}>
                            <ProductMoreInfo value={pr.product}/>
                            <div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center',  marginTop: '-24px', justifyContent: 'flex-end'}}>
                            <Typography sx={{fontSize: '14pt', lineHeight: '14pt'}}>{pr.count} шт.</Typography>
                            </div>
                            <div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '10px'}}>
                              { pr.box && <Typography sx={{fontSize: '12pt', lineHeight: '12pt', marginRight: "10px"}}>{pr.box === '0'? 'Нераспределенный товар': `Короб: ${pr.box}`}</Typography>}
                              { admin && pr.addr && <Typography sx={{fontSize: '12pt', lineHeight: '12pt'}}>Адрес: {pr.addr}</Typography>}
                            </div>
                          </CardContent>
                        </Card>          
                      )}      
                  </div>
                </CardContent>
              </Card>
            )
          })}
        </Scrollbars>
        }
        { admin && 
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 'calc( 1% + 5px)', marginRight: "10px"}}>
            <IconButton aria-label="add" onClick={() => {printMoveGuide()}} disableRipple> 
              <PrintIcon sx={{'&:hover': hoverStyle}}/>
            </IconButton>
          </div>
        }
      </div>
    </Dialog>
  );
}


